import { AboutMetaInfo } from "../MetaInfo";
import { ABOUT_MAP_OPTIONS } from "../options";
import { MapMapbox } from "../components/Map";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

import logoTeachCrunch from '../images/about/techcrunch@2x.png';
import logoThrillist from '../images/about/thrillist@2x.png';
import logoGeoAwesomeness from '../images/about/geoawesomeness@2x.png';
import logoProductHunt from '../images/about/producthunt@2x.png';
import backImage from '../images/about/back.jpg';


export default function AboutView() {
    return (
        <div className="antialiased">
            <AboutMetaInfo />

            <header
                className="h-72 flex justify-center items-center bg-[#888] bg-cover bg-no-repeat bg-bottom bg-blend-multiply"
                style={{ backgroundImage: `url(${backImage})` }}>
                <h1 className="text-5xl font-light text-white text-center px-4 max-sm:text-3xl">
                    World wide job posts aggregator
                </h1>
            </header>

            <main className="flex flex-col w-full mx-auto max-w-5xl text-sm font-light leading-relaxed px-4">

                <section className="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-8 mt-8">
                    <div className="space-y-4">
                        <p>
                            <a href="https://whoishiring.io">whoishiring.io</a> connects
                            people with their dream job easily by showing
                            them who is hiring anywhere in the world!
                        </p>
                        <p>
                            We present the most relevant opportunities on a map
                            where seekers can easily find out who is hiring in the location
                            that is most attractive to them, whether it's down the street or
                            on the opposite side of the globe.
                        </p>
                        <p>
                            Recruiters love <a href="https://whoishiring.io">whoishiring.io</a> because
                            we free them up to work on what they love: recruiting.
                            Companies can easily connect their existing recruitment tools
                            and automatically sync an unlimited number of job postings daily.
                        </p>
                        <p>
                            Why we are doing this?
                            Because we strive to be the first
                            website you go to find your dream job, or your best employee!
                        </p>
                        <p className="text-center text-lg">
                            "We know Who Is Hiring"
                        </p>
                    </div>

                    <Card className="self-start">
                        <CardHeader>
                            <CardTitle className="text-3xl font-light text-brand">Follow us</CardTitle>
                        </CardHeader>
                        <CardContent className="flex flex-col gap-5">
                            <div className="flex gap-3">
                                <a className="fa-stack fa-lg text-cyan no-underline hover:opacity-80"
                                    rel="noopener noreferrer" target="_blank"
                                    href="https://twitter.com/whoishiringio">
                                    <i className="fa fa-circle-thin fa-stack-2x" />
                                    <i className="fa fa-twitter fa-stack-1x" />
                                </a>
                                <a className="fa-stack fa-lg text-cyan no-underline hover:opacity-80"
                                    rel="noopener noreferrer" target="_blank"
                                    href="https://www.linkedin.com/company/whoishiring.io">
                                    <i className="fa fa-circle-thin fa-stack-2x" />
                                    <i className="fa fa-linkedin fa-stack-1x" />
                                </a>
                                <a className="fa-stack fa-lg text-cyan no-underline hover:opacity-80"
                                    rel="noopener noreferrer" target="_blank"
                                    href="https://www.facebook.com/whoishiringio/">
                                    <i className="fa fa-circle-thin fa-stack-2x" />
                                    <i className="fa fa-facebook fa-stack-1x" />
                                </a>
                            </div>
                            <div className="flex flex-col gap-2">
                                <CardTitle className="text-3xl font-light text-brand">Have a question?</CardTitle>
                                <a href="mailto:mail@whoishiring.io"
                                    className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-cyan text-cyan hover:bg-cyan/10 no-underline text-sm font-medium w-fit transition-colors">
                                    <i className="fa fa-envelope" />
                                    mail@whoishiring.io
                                </a>
                            </div>
                        </CardContent>
                    </Card>
                </section>

                <section className="mt-12">
                    <Separator />
                    <div className="flex justify-center flex-wrap gap-4 py-12">
                        <a href="https://techcrunch.com/2016/10/26/whoishiring-tells-you-who-is-hiring-and-where/"
                            rel="noopener noreferrer" target="_blank"
                            className="hover:bg-muted rounded p-2 no-underline transition-colors">
                            <img src={logoTeachCrunch} className="h-20 max-sm:h-14" />
                        </a>
                        <a href="https://www.thrillist.com/news/nation/whoishiring-aggregates-startup-jobs-in-a-useful-map"
                            rel="noopener noreferrer" target="_blank"
                            className="hover:bg-muted rounded p-2 no-underline transition-colors">
                            <img src={logoThrillist} className="h-20 max-sm:h-14" />
                        </a>
                        <a href="http://geoawesomeness.com/website-maps-job-openings-tech-startups-around-world/"
                            rel="noopener noreferrer" target="_blank"
                            className="hover:bg-muted rounded p-2 no-underline transition-colors">
                            <img src={logoGeoAwesomeness} className="h-20 max-sm:h-14" />
                        </a>
                        <a href="https://www.producthunt.com/posts/who-is-hiring"
                            rel="noopener noreferrer" target="_blank"
                            className="hover:bg-muted rounded p-2 no-underline transition-colors">
                            <img src={logoProductHunt} className="h-20 max-sm:h-14" />
                        </a>
                    </div>
                    <Separator />
                </section>

                <section className="mt-12">
                    <blockquote className="border-l-4 border-border pl-3 m-0">
                        <p className="m-0 text-xl italic text-foreground max-sm:text-xs">
                            The mission, ultimately, is to make it a lot easier to find jobs around and near you,
                            a mission that is noble as it is useful.
                        </p>
                        <small className="text-muted-foreground">— John Biggs, TechCrunch</small>
                    </blockquote>
                </section>

                <section className="mt-12 mb-8">
                    <blockquote className="border-l-4 border-border pl-3 m-0">
                        <p className="m-0 text-xl italic text-foreground max-sm:text-xs">Simple but awesome.</p>
                        <small className="text-muted-foreground">— Aleks Buczkowski, Geoawesomeness</small>
                    </blockquote>
                </section>

            </main>

            <MapMapbox
                disableDoubleClickZoom
                navigationControlOptions={{ showZoom: true, showCompass: false }}
                zoom={ABOUT_MAP_OPTIONS.zoom}
                marker={ABOUT_MAP_OPTIONS.center}
                center={ABOUT_MAP_OPTIONS.center}
                className="h-[500px] mt-8">
                <div className="absolute inset-0 bg-black/5" />
            </MapMapbox>
        </div>
    );
}
